import React from 'react';
import '../css/Footer.css';
import logo from '../images/logo.svg';
import { SmoothScrollLink } from 'organism-react-scroll-nav';

function Footer() {
  return (
    <div className="footer jumbotron-fluid">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 mx-auto">
            <img src={logo} className="img-fluid" alt="logo" />
            <p className="text-justify">
              Jl. Raya Dongkal, RT.001/RW.006, Cipondoh Makmur, Kec. Cipondoh, Kota Tangerang, Banten 15148
            </p>
            <span>Phone: +6285161016522</span> <br></br>
            <span>Email: code@faisalhakim.com</span>
          </div>
          <div className="col-lg-3 mx-auto my-auto">
            <h4>Useful Links</h4>
            <ul className="text-left">
              <li>
                <SmoothScrollLink targetId="Home">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> Home{' '}
                </SmoothScrollLink>
              </li>
              <li>
                <SmoothScrollLink targetId="AboutUs">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> About Us{' '}
                </SmoothScrollLink>
              </li>
              <li>
                <SmoothScrollLink targetId="Products">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> Products{' '}
                </SmoothScrollLink>
              </li>
              <li>
                <SmoothScrollLink targetId="OrderNow">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> OrderNow{' '}
                </SmoothScrollLink>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 mx-auto my-auto">
            <h4>Products</h4>
            <ul className="text-left">
              <li>
                <SmoothScrollLink targetId="Products">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> All{' '}
                </SmoothScrollLink>
              </li>
              <li>
                <SmoothScrollLink targetId="Products">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> Chair{' '}
                </SmoothScrollLink>
              </li>
              <li>
                <SmoothScrollLink targetId="Products">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> Lamp{' '}
                </SmoothScrollLink>
              </li>
              <li>
                <SmoothScrollLink targetId="Products">
                  <i className="fa fa-chevron-right" aria-hidden="true"></i> Table{' '}
                </SmoothScrollLink>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 mx-auto my-auto">
            <h4>Our Social Networks</h4>
            <ul className="text-left">
              <li>
                <i className="fa fa-facebook-square" aria-hidden="true"></i>
                &emsp;Facebook
              </li>
              <li>
                <a href="https://instagram.com/awoskyhakim">
                  <i className="fa fa-instagram" aria-hidden="true"></i>
                  &emsp;Instagram
                </a>
              </li>
              <li>
                <i className="fa fa-twitter-square" aria-hidden="true"></i>
                &emsp;Twitter
              </li>
              <li>
                <a href="https://wa.me/+6285161016522">
                  <i className="fa fa-whatsapp" aria-hidden="true"></i>
                  &emsp;Whatsapp
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p className="copyright text-center">Copyright © 2020 WeSpace | All Right Reserved</p>
    </div>
  );
}

export default Footer;
